import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";

const Slider = React.forwardRef(
  ({ className, value, defaultValue, onPointerDown, ...props }, ref) => {
    const values = value ?? defaultValue ?? [0];

    const handlePointerDown = (e) => {
      const target = e.target;

      // Only allow pointer down if it started on a thumb (drag-only)
      if (target instanceof HTMLElement) {
        const startedOnThumb = target.closest('[role="slider"]');
        if (!startedOnThumb) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }

      onPointerDown?.(e);
    };

    return (
      <SliderPrimitive.Root
        ref={ref}
        value={value}
        defaultValue={defaultValue}
        onPointerDown={handlePointerDown}
        className={cn(
          "relative flex w-full touch-none select-none items-center",
          className
        )}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20">
          <SliderPrimitive.Range className="absolute h-full bg-primary" />
        </SliderPrimitive.Track>

        {Array.isArray(values) &&
          values.map((_, index) => (
            <SliderPrimitive.Thumb
              key={index}
              className={cn(
                "block h-5 w-5 rounded-full border border-primary/50 bg-background shadow",
                "cursor-grab active:cursor-grabbing",
                "transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
                "disabled:pointer-events-none disabled:opacity-50"
              )}
            />
          ))}
      </SliderPrimitive.Root>
    );
  }
);

Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
